import type { LandingCopy } from './types'

export const landingEn: LandingCopy = {
  heroTitle: 'Understand English as you read.',
  heroSubtitleLines: ['Tap any word.', "We'll explain it.", "You'll remember it."],
  demoHint: 'No account required',
  demoReadLabel: 'Read',
  demoUnderstandLabel: 'Understand',
  demoTapHint: 'Tap a highlighted word to see what it means',
  demoMeans: 'Means',
  demoInContext: 'In this sentence',
  demoExampleLabel: 'Example',
  demoLocalizedNote: 'Sign up to save words and meet them again in review.',
  signUpToSave: 'Sign up to save words',
  savedNudge: 'Saved — you’ll review “{word}” tomorrow.',
  capabilitiesTitle: 'Your progress engine',
  capabilitiesSubtitle:
    'Not just reading. The words you choose become articles, practice, tests, and review — one loop that continuously moves you forward.',
  capabilities: [
    {
      title: 'Read & understand',
      body: 'Tap any word or phrase for a clear explanation in context.',
    },
    {
      title: 'Your vocabulary',
      body: 'Save what matters — your personal list to grow from.',
    },
    {
      title: 'Memory refresh',
      body: 'Spaced repetition when you’re about to forget.',
    },
    {
      title: 'Articles for your words',
      body: 'AI writes reading at your level around vocabulary you saved.',
    },
    {
      title: 'Practice',
      body: 'Stories and lessons built from words you already know.',
    },
    {
      title: 'Vocabulary tests',
      body: 'Challenge yourself and see what has really stuck.',
    },
  ],
  finalTitle: 'Ready to turn your words into progress?',
  getStarted: 'Get started free',
  signIn: 'Sign in',
  footerFaq: 'FAQ',
  footerPrivacy: 'Privacy Policy',
  footerTerms: 'Terms of Service',
  localeSwitcherLabel: 'Language',
}
